import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/PageHeader';
export function NotFound() {
  return <>
      <PageHeader eyebrow="Page Not Found" title="This page is no longer available" description="The page you are looking for may have been moved. You can return home or view our fiduciary services." data-id="element-329" data-mp="w4jal1haegag" />
      <section className="bg-white" data-id="element-330" data-mp="1a4270x0qk36x">
        <div className="mx-auto flex max-w-content flex-col gap-4 px-6 py-20 sm:flex-row lg:px-8" data-id="element-331" data-mp="1a2zk106jakwa">
          <Link to="/" className="bg-navy-900 px-7 py-3.5 text-center text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-navy-800" data-id="element-332" data-mp="1f23rnmdt8aki">
            Return Home
          </Link>
          <Link to="/services" className="border border-navy-300 px-7 py-3.5 text-center text-[15px] font-medium text-navy-800 transition-colors duration-150 ease-out hover:border-navy-600" data-id="element-333" data-mp="1nxjtoqopxw16">
            Explore Our Services
          </Link>
        </div>
      </section>
    </>;
}